import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=2f0e2781&scoped=true&"
import script from "./ForgetPassword.vue?vue&type=script&lang=js&"
export * from "./ForgetPassword.vue?vue&type=script&lang=js&"
import style0 from "./_forgetPassword.scss?vue&type=style&index=0&id=2f0e2781&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0e2781",
  null
  
)

export default component.exports